import React, { useEffect, useState } from "react";
import Section from "@/components/ui/section";
import Slick from "@/components/ui/carousel/slick";
import Image from "next/image";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import ExpandIcon from "@/icons/expand-icon";
import classNames from "classnames";
import ProductDetails from "./product-details";

export default function ProductCarousel({ product }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [index, setIndex] = useState(-1);

  return (
    <Section className="mt-[100px] bg-beige">
      <div className="lg:grid lg:grid-cols-2 lg:auto-rows-auto flex flex-col w-full">
        {/* Thumbnails and Carousel wrapped in a common parent */}
        <div className="w-full flex items-start justify-start gap-2">
          <div className="lg:flex hidden flex-col w-[100px] shrink-0 gap-2 sticky top-[140px] h-[calc(100vh-200px)] overflow-y-auto">
            {product?.images?.data?.map((row, key) => (
              <Thumbnail
                data={row?.attributes}
                isActive={currentSlide === key}
                key={"thumbnail" + key}
                onClick={() => setCurrentSlide(key)}
              />
            ))}
          </div>
          <div className="w-full overflow-hidden shrink sticky top-[140px] lg:h-[calc(100vh-200px)] md:h-[500px] h-[300px]">
            <Slick
              dots={true}
              navigation={false}
              slidesToScroll={1}
              slidesToShow={1}
              fade={false}
              currentSlide={currentSlide}
              onSlideChange={setCurrentSlide}
              autoplay={false}
              dotsClass={"slick-dots slick-thumb product"}
              appendDots={(dots) => <ul>{dots}</ul>}
              customPaging={(i) => (
                <div
                  className={`ft-slick__dots--custom_product ${
                    currentSlide === i ? "active" : ""
                  }`}
                ></div>
              )}
            >
              {product?.images?.data?.map((row, key) => (
                <Card
                  data={row?.attributes}
                  isActive={currentSlide === key}
                  key={"homeBanner" + key}
                  onClick={() => setIndex(key)}
                />
              ))}
            </Slick>
          </div>
        </div>

        {/* Product details container */}
        <ProductDetails product={product} />
      </div>

      <Lightbox
        slides={product?.images?.data?.map((row) => {
          return {
            src: row?.attributes?.url,
          };
        })}
        styles={{ root: { "--yarl__color_backdrop": "rgba(0, 0, 0, .9)" } }}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
      />
    </Section>
  );
}
const Card = ({ data, onClick }) => {
  return (
    <div className="w-full lg:h-[calc(100vh-200px)] md:h-[500px] h-[300px] relative overflow-hidden">
      <Image
        src={data?.url}
        fill
        alt={data?.alternativeText}
        priority={true}
        className="object-cover object-center w-full h-full"
        sizes="(max-width: 768px) 768px, (max-width: 1200px) 1200, 1400px"
      />
      <ExpandIcon
        className="absolute top-4 right-4 w-8 cursor-pointer lg:hover:scale-110 transition-all duration-500 ease"
        onClick={onClick}
      />
    </div>
  );
};
const Thumbnail = ({ data, onClick, isActive }) => {
  return (
    <div
      className={classNames(
        "w-full h-[100px] relative overflow-hidden border-[1px] transition-all duration-300 ease cursor-pointer",
        {
          "border-darkBrown": isActive,
          "border-transparent": !isActive,
        }
      )}
    >
      <Image
        src={data?.url}
        fill
        onClick={onClick}
        alt={data?.alternativeText}
        priority={true}
        className="object-cover object-center w-full h-full"
        sizes="(max-width: 768px) 768px, (max-width: 1200px) 1200, 1400px"
      />
    </div>
  );
};
